import styled, { css } from 'styled-components';

export const ZoneInputBox = styled.div`
  width: ${(props) => (props.wide ? '130px' : '100px')};
  height: 40px;
  border-radius: 4px;
  border: solid 1px;
  border-color: #d5d5d5;
  background-color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  input {
    width: ${(props) => (props.wide ? '90%' : '42px')};
    height: 100%;
    border: none;
    background-color: inherit;
    outline: none;
    color: ${(props) => (props.error ? '#d33d34' : 'var(--cp-text, #fff)')};
    font-size: 15px;
    text-align: end;
    margin-right: 10px;
  }
  span {
    opacity: 0.7;
    color: ${(props) => (props.error ? '#d33d34' : 'var(--cp-text, #fff)')};
    font-size: 15px;
  }
  input[type='time']::-webkit-calendar-picker-indicator {
    filter: invert(100%);
  }

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      border-color: ${(props) => (props.theme.theme === 'dark' ? '#d5d5d5' : '#333')};

      ${(props) =>
        props.theme.theme === 'light' &&
        css`
          input[type='time']::-webkit-calendar-picker-indicator {
            filter: none;
          }
        `}
    `}
`;
